import '../common.scss';
import './styles.scss';
import { useNavigate } from 'react-router-dom';
import Prefooter from '../../components/Prefooter';
import MainScreen from '../../components/MainSreen';
import Back from '../../assets/solut.jpg';
import Sol1 from '../../assets/solut1.jpg';
import Sol2 from '../../assets/solut2.jpg';
import Sol3 from '../../assets/solut3.jpg';
import Sol4 from '../../assets/solut4.jpg';
import Sol5 from '../../assets/solut5.jpg';
import Sol6 from '../../assets/solut6.jpg';
import { useOutletContext } from 'react-router-dom';

const MainPage = ({ onFormClick }) => {
  const { setFormOpen } = useOutletContext();
  const navigate = useNavigate();

  return (
    <div className='content'>
      <MainScreen
        tag='For companies hiring'
        title={
          <span>
            AI-powered talent matching <b>across industries</b>
          </span>
        }
        text='We believe every candidate has a perfect role where they can succeed. Our mission is to help organizations find those ideal matches quickly, affordably, and with zero risk.'
        button='Contact us'
        image={Back}
        onClick={() => setFormOpen('Looking to hire talent')}
      />
      <div className='servicesSection'>
        <div className='serviceCard'>
          <span className='serviceCardImage'>
            <img src={Sol1} />
          </span>
          <div className='serviceCardInfo'>
            <span className='serviceCardTitle'>Healthcare</span>
            <span className='serviceCardText'>
              Connect with exceptional healthcare professionals, thoroughly screened for quality and reliability. Focus on patient
              care while we handle staffing.
            </span>
            <span className='serviceCardButton' onClick={() => setFormOpen('Looking to hire talent')}>
              Get Started
            </span>
          </div>
        </div>

        <div className='serviceCard'>
          <span className='serviceCardImage'>
            <img src={Sol5} />
          </span>
          <div className='serviceCardInfo'>
            <span className='serviceCardTitle'>Technology</span>
            <span className='serviceCardText'>
              Scale your development team with top-tier, pre-screened talent. Access a global pool of skilled software engineers
              at competitive rates.
            </span>
            <span className='serviceCardButton' onClick={() => setFormOpen('Looking to hire talent')}>
              Get Started
            </span>
          </div>
        </div>

        <div className='serviceCard'>
          <span className='serviceCardImage'>
            <img src={Sol6} />
          </span>
          <div className='serviceCardInfo'>
            <span className='serviceCardTitle'>Marketing</span>
            <span className='serviceCardText'>
              Connect with top-tier marketing professionals, pre-screened for your convenience. Focus on growth while we handle
              the hiring.
            </span>
            <span className='serviceCardButton' onClick={() => setFormOpen('Looking to hire talent')}>
              Get Started
            </span>
          </div>
        </div>

        <div className='serviceCard'>
          <span className='serviceCardImage'>
            <img src={Sol3} />
          </span>
          <div className='serviceCardInfo'>
            <span className='serviceCardTitle'>Revenue</span>
            <span className='serviceCardText'>
              Boost your revenue with top sales professionals, pre-screened to meet your specific business needs.
            </span>
            <span className='serviceCardButton' onClick={() => setFormOpen('Looking to hire talent')}>
              Get Started
            </span>
          </div>
        </div>

        <div className='serviceCard'>
          <span className='serviceCardImage'>
            <img src={Sol2} />
          </span>
          <div className='serviceCardInfo'>
            <span className='serviceCardTitle'>Executive Support</span>
            <span className='serviceCardText'>
              Find your perfect executive assistant, pre-screened for your convenience. Focus on productivity while we handle the
              hiring.
            </span>
            <span className='serviceCardButton' onClick={() => setFormOpen('Looking to hire talent')}>
              Get Started
            </span>
          </div>
        </div>

        <div className='serviceCard'>
          <span className='serviceCardImage'>
            <img src={Sol4} />
          </span>
          <div className='serviceCardInfo'>
            <span className='serviceCardTitle'>Early Careers</span>
            <span className='serviceCardText'>
              Cultivating the next generation of talent. Discover bright, motivated interns and early career professionals across
              various disciplines.
            </span>
            <span className='serviceCardButton' onClick={() => setFormOpen('Looking to hire talent')}>
              Get Started
            </span>
          </div>
        </div>
      </div>
      <div className='weWorkSection'>
        <span className='sectionTitle'>How we work</span>
        <span className='sectionTitleText'>A simple, risk-free process powered by cutting-edge AI</span>
        <div className='weWorkCards'>
          <div className='weWorkCard'>
            <span className='weWorkCardCount'>01</span>
            <span className='weWorkCardTitle'>Unique matches tailored to you</span>
            <span className='weWorkCardText'>Pre-vetted professionals who perfectly match your requirements.</span>
          </div>

          <div className='weWorkCard'>
            <span className='weWorkCardCount'>02</span>
            <span className='weWorkCardTitle'>Affordable, tech-powered</span>
            <span className='weWorkCardText'>Cutting-edge AI automates search, giving you talent at a fraction of the cost.</span>
          </div>

          <div className='weWorkCard'>
            <span className='weWorkCardCount'>03</span>
            <span className='weWorkCardTitle'>No commitment, no risk</span>
            <span className='weWorkCardText'>You only pay if you hire. No long-term commitment or upfront fees.</span>
          </div>

          <div className='weWorkCard'>
            <span className='weWorkCardCount'>04</span>
            <span className='weWorkCardTitle'>We handle the paperwork</span>
            <span className='weWorkCardText'>We take care of all paperwork and regulations.</span>
          </div>

          <div className='weWorkCard'>
            <span className='weWorkCardCount'>05</span>
            <span className='weWorkCardTitle'>Candidates in 6 hours</span>
            <span className='weWorkCardText'>Interested, motivated candidates ready to join your team.</span>
          </div>
        </div>
      </div>
      <Prefooter
        title='Ready to find your next hire?'
        text={`Tell us what you need. We'll have candidates for you within six hours.`}
        button='Contact us'
        onClick={() => setFormOpen('Looking to hire talent')}
      />
    </div>
  );
};

export default MainPage;
